/*
 * The kit's dock drag (2 Nov 2026), typed here rather than read from the kit's types, so an installed kit from before it
 * still builds: its members are then simply absent, and this app's pages take no drops.
 */
import * as kit from '@flobi/asset-library/dock';

export type DropKind = 'picture' | 'video' | 'sound' | 'model' | 'text' | 'file';

export interface DroppedItem {
  kind: DropKind;
  name?: string;
  mime?: string;
  url?: string;
  text?: string;
  assetId: string | null;
  mediaAssetId: string | null;
  fileId: string | null;
  driveFileId: string | null;
  width?: number;
  height?: number;
  duration?: number;
  size?: number;
  [field: string]: unknown;
}

export interface DropPoint {
  x: number | null;
  y: number | null;
  inside: boolean;
  rect: DOMRect | null;
  from: string | null;
}

interface DropTarget {
  name?: string | null;
  takes?: '*' | DropKind[];
  ref?: { current: Element | null };
  enabled?: boolean;
  blocked?: boolean | string | null;
  standby?: boolean;
  onDrop: (items: DroppedItem[], at: DropPoint) => void | Promise<void | { message?: string; refused?: boolean; quiet?: boolean }>;
}

interface DropParcel {
  id: null;
  type: 'media' | 'text';
  name: string;
  from: { app: string | null; id: null; name: null; url: null };
  mode: 'link' | 'copy';
  items: Array<{ mediaAssetId: string | null; driveFileId: string | null; name: string; mime: string | null; url: string | null; thumbnailUrl: string | null; width: number; height: number; duration: number; text: string | null; role: null }>;
  payload: null;
  [field: string]: unknown;
}

const dock = kit as unknown as {
  useDropTarget?: (target: DropTarget) => void;
  toParcel: (items: DroppedItem[], o?: { name?: string | null; from?: string | null }) => DropParcel;
  dropWords: (items: DroppedItem[]) => string;
};

/** Module level: one hook identity. A no-op on an older kit. */
export const useDropTarget = dock.useDropTarget ?? ((() => {}) as (target: DropTarget) => void);
export const { toParcel, dropWords } = dock;
